import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
import {GlobalConstants} from 'src/app/global-constants'

@Component({
  selector: 'generate-selection-letters',
  templateUrl: './generate-selection-letters.component.html'
})
export class GenerateSelectionLetttersModalComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {

  }

 datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  @ViewChild('generateLettersModal', { static: true }) generateLettersModal: any;
  action: any = {}
  ngOnChanges() {
    if (this.selections && this.selections.selectedSelections && this.selections.selectedSelections.length) {
      this.action.selectionTemplate = null
      this.getNoticeType().then(noticeTypes => {
        this.downloadNotice = { noticeType: this.noticeTypes.selectionLetterTag, overwriteExistingLetters: "no" };
      });
      this.generateLettersModal.show();
    }
  }

  noticeTypes: any = {};
  noticeTypesLoading: boolean = false;
  downloadNotice: any = {};
  getNoticeType() {
    this.noticeTypes = {};
    const url = this.appConstants.endPoints.certificatesEndPoint + 'admin/critical-components/settings';
    this.noticeTypesLoading = true;

    return new Promise((resolve, reject) => {
      this.service.get(url, {})
        .pipe(finalize(() => {
          this.noticeTypesLoading = false;
        }))
        .subscribe(data => {
          if (data) {
            if (data.selectionLetterTag.id)
              this.noticeTypes['selectionLetterTag'] = { id: data.selectionLetterTag.id, name: data.selectionLetterTag.name, index: 1 };
            if (data.reminderLetterTag.id)
              this.noticeTypes['reminderLetterTag'] = { id: data.reminderLetterTag.id, name: data.reminderLetterTag.name, index: 2 };
            if (data.lateNoticeLetterTag.id)
              this.noticeTypes['lateNoticeLetterTag'] = { id: data.lateNoticeLetterTag.id, name: data.lateNoticeLetterTag.name, index: 3 };
          }
          resolve(this.noticeTypes)
        }
          , error => {
            this.errorService.errorHandling(error).then(res => {
              this.error = res;
            });
          })
    });

  }

  settings: any = {};
  public getSettings() {
    return new Promise((resolve, reject) => {
      const url = this.appConstants.endPoints.certificatesEndPoint + 'admin/critical-components/settings';
      this.service.get(url, {})
        .subscribe(data => {
          if (data) {
            resolve(data);
          }
        },
          error => {
            this.errorService.errorHandling(error).then(res => {
              this.error = res;
            });
          })
    });
  }

  selectionTemplates: any = [];
  selectionTemplatesLoader: boolean = false;
  getSelectionTemplates() {
    this.selectionTemplates = []
    this.action.selectionTemplate = {};
    this.selectionTemplatesLoader = true;
    this.getSettings().then((res) => {

      this.settings = res;
      const url = this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/query-documents'
      this.service.post(url, {}, {
        aboutPaths: [this.settings.templateLibrary.aboutPath],
        isPaging: true,
        pageSize: 100,
        pageNumber: 1,
        tagIds: [this.downloadNotice.noticeType.id],
      })
        .pipe(finalize(() => {
          this.selectionTemplatesLoader = false;
        }))
        .subscribe(data => {
          this.selectionTemplates = data && data.searchResults ? data.searchResults : [];
        }, error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
    })
  }

  selectionsModalLoader: boolean = false;
  createSelectionLetter() {
    const url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/batch-operations/create-selection-letters';
    let modelSchema = {
      "templateId": this.action.selectionTemplate.id,
      "selections": this.selections.selectedSelections.map(ss => { return { id: ss.id } }),
      "tagId": this.downloadNotice.noticeType.id,
      "overrideLetters": this.downloadNotice.overrideLetters
    }
    this.noticeTypesLoading = true;
    this.service.post(url, {}, modelSchema).pipe(finalize(() => {
      this.noticeTypesLoading = false;
    }))
      .subscribe(data => {
        this.generateLettersModal.hide();
        this.emitSuccess.emit(true)
        this.toastr.success(this.translate.instant('administration_selectionsCreatedSuccessfully_label'), this.translate.instant('administration_success_label'))
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }
}